import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {PipesModule} from './pipes/pipes.modules';
import {SessionService} from './services/session.service';

import {IonicStorageModule}           from '@ionic/storage-angular';
import {Drivers}                      from '@ionic/storage';
import {HttpClientModule}             from '@angular/common/http';
import {SharedComponentsModule}       from './components/shared-components.module';
import {ServiceWorkerModule}          from '@angular/service-worker';
import {environment}                  from '../environments/environment';
import {LuxonModule}                  from 'luxon-angular';
import {AmplifyAuthenticatorModule}   from '@aws-amplify/ui-angular';
import { ImgModalComponentComponent } from './modals/img-modal-component/img-modal-component.component';
import {OneSignal}                    from "@awesome-cordova-plugins/onesignal/ngx";
import {DocumentViewer}               from "@awesome-cordova-plugins/document-viewer/ngx";


// import { DateAddDaysPipe } from './date-add-days.pipe';

export function appInit(sessionService: SessionService) {
    return () => sessionService.setUserListner();
}

@NgModule({
    declarations: [
        AppComponent,
        ImgModalComponentComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        AmplifyAuthenticatorModule,
        ReactiveFormsModule,
        PipesModule.forRoot(),
        IonicModule.forRoot(),
        IonicStorageModule.forRoot({
            name: '__mydb',
            driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
        }),
        AppRoutingModule,
        LuxonModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the app is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000',
        }),
        SharedComponentsModule,
    ],
    providers: [{provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
        {
            provide: APP_INITIALIZER,
            useFactory: appInit,
            multi: true,
            deps: [SessionService],
        },
        //  WpService,
     //   Clipboard,
        // {provide: EmailComposer},
        OneSignal,
        DocumentViewer,
    ],
    bootstrap: [AppComponent],
    exports: []
})
export class AppModule {
}
